<script setup>
/**
 * Fixed page header bar anchored to the top of the layout.
 *
 * @status recommended
 * @group layout
 * @useWhen Building a top app bar containing a toolbar and navigation controls
 * @within hr-layout
 * @see https://quasar.dev/layout/header-and-footer Quasar q-header API
 */
defineOptions({ name: 'HrHeader' });
</script>

<template>
  <q-header
    v-bind="$attrs"
    class="hr-top-bar"
  >
    <!-- @slot Top bar content, typically an HrToolbar. -->
    <slot />
  </q-header>
</template>

<style scoped>
.hr-top-bar {
  background: var(--app-comp-top-bar-container, var(--q-primary));
  color: var(--app-comp-top-bar-on-container, white);
  --_chip-color:              var(--app-comp-top-bar-on-container, white);
  --_chip-border:             var(--app-comp-top-bar-on-container, white);
  --_chip-icon-color:         var(--app-comp-top-bar-on-container, white);
  --_icon-btn-standard-color: var(--app-comp-top-bar-on-container, white);
  --_btn-color:               var(--app-comp-top-bar-on-container, white);
  --_btn-border:              var(--app-comp-top-bar-on-container, white);
}
</style>
